/*
 * @创建文件时间: 2019-11-10 18:22:36
 * @最后修改人: lfq
 * @最后修改时间: 2020-05-02 17:25:35
 * @联系Qq:1638245306
 * @文件介绍: 电子档案管理
 */
export default [{
    path: 'projectLibraryTable',
    name: 'projectLibraryTable',
    meta: {
        title: '项目库',
        auth: true
    },
    component: () =>
        import ('@/views/maintenanceData/fileManagement/projectLibraryTable') 
},
{
    path: 'dataDocument',
    name: 'dataDocument',
    meta: {
        title: '资料文件管理',
        auth: true
    },
    component: () =>
        import ('@/views/maintenanceData/fileManagement/dataDocument')
},
{
    path: 'bridgeTunnel',
    name: 'bridgeTunnel',
    meta: {
        title: '桥隧档案数据',
        auth: true
    },
    component: () =>
        import ('@/views/maintenanceData/fileManagement/bridgeTunnel')
},
{
    path: 'efmBridgeMaintenanceFile',
    name: 'efmBridgeMaintenanceFile',
    meta: {
        title: '桥梁维修档案',
        auth: true
    },
    component: () =>
        import ('@/views/maintenanceData/fileManagement/efmBridgeMaintenanceFile')
},
{
    path: 'efmFacilityMaintenanceFile',
    name: 'efmFacilityMaintenanceFile',
    meta: {
        title: '设施维修档案',
        auth: true
    },
    component: () =>
        import ('@/views/maintenanceData/fileManagement/efmFacilityMaintenanceFile')
},
{
    path: 'efmOilRepairFile',
    name: 'efmOilRepairFile',
    meta: {
        title: '油路修补档案',
        auth: true
    },
    component: () =>
        import ('@/views/maintenanceData/fileManagement/efmOilRepairFile')
},
{
    path: 'efmRcRepairFile',
    name: 'efmRcRepairFile',
    meta: {
        title: '路面裂缝修补档案',
        auth: true
    },
    component: () =>
        import ('@/views/maintenanceData/fileManagement/efmRcRepairFile')
}
]